import request from './request'

// 获取小程序内购商品列表
export function getGoodsList(extUuid) {
  return request({
    url: '/api/goods/getGoodsList',
    method: 'GET',
    params: {
      extUuid,
    },
  })
}

/*
 * 直接付费账单接口
 * payload:
 * beginTime,
 * endTime,
 * page,
 * pageSize
 */
export function extGoodsPreDayDetail(params) {
  return request({
    url: '/api/anchorBill/extGoodsPrePayDetail',
    method: 'GET',
    params,
  })
}


/*
 * 礼物收益汇总账单接口
 * beginTime,
 * endTime,
 * page,
 * pageSize
 */
export function extGoodsBackPaySummary(params) {
  return request({
    url: '/api/anchorBill/extGoodsBackPaySummary',
    method: 'GET',
    params,
  })
}

/* 按小程序查询月份商品账单接口
 * params:
 * extUuid,
 * month,
 * page,
 * pageSize,
 */
export function extGoodsBackPayDetail(params) {
  return request({
    url: '/api/anchorBill/extGoodsBackPayDetail',
    method: 'GET',
    params,
  })
}

/* 本月累计使用明细接口
 * params:
 * page,
 * pageSize,
 */
export function profileCurrentGoodsBackPaySummary(params) {
  return request({
    url: '/api/anchorBill/profileCurrentGoodsBackPaySummary',
    method: 'GET',
    params,
  })
}

/* 本月商品使用明细接口
 * params:
 * goodsUuid,
 */
export function profileCurrentGoodsBackPayDetail(params) {
  return request({
    url: '/api/anchorBill/profileCurrentGoodsBackPayDetail',
    method: 'GET',
    params,
  })
}

// 未缴账单接口
export function anchorServiceBackBill(params) {
  return request({
    url: '/api/anchorBill/anchorServiceBackBill',
    method: 'GET',
    params,
  })
}

/*
 * 安装小程序
 * @param data.extUuid
 * @param data.extVersionId
 * @param data.isCoverInstall, 只对非正式版本有效, 0 为正常安装, 1 覆盖安装
 */
export function installExt(data) {
  return request({
    url: '/api/appstore/installExt',
    method: 'POST',
    data,
  })
}

/*
 * 卸载小程序
 * data.extUuid
 * data.extVersionId
 * data.rejectFeeChange  1/null
 */
export function uninstallExt(data) {
  return request({
    url: '/api/appstore/uninstallExt',
    method: 'POST',
    data,
  })
}


/*
 * 人气榜
 */
export function popularList() {
  return request({
    url: '/api/rank/popular',
    method: 'GET',
  })
}

/*
 * 财富榜
 */
export function richList() {
  return request({
    url: '/api/rank/rich',
    method: 'GET',
  })
}


/*
 * 小程序商店banner管理
 */
export function getBannerList() {
  return request({
    url: '/api/appstoreSocial/getBannerList',
    method: 'GET',
  })
}

/*
 * 小程序标签
 */
export function tagList() {
  return request({
    url: '/api/appstore/tagList',
    method: 'GET',
  })
}

/*
 * 查询小程序列表接口
 * 根据小程序标签，查询表现下的小程序列表信息
 */
export function getExtList(params) {
  return request({
    url: '/api/appstore/extList',
    method: 'GET',
    params,
  })
}

/*
 * 小程序点赞接口
 * extUuid
 */
export function likeExt(data) {
  return request({
    url: '/api/appstoreSocial/extLike',
    method: 'POST',
    data,
  })
}

/*
 * 小程序取消点赞接口
 * extUuid
 */
export function unLikeExt(data) {
  return request({
    url: '/api/appstoreSocial/extUnlike',
    method: 'POST',
    data,
  })
}

/*
 * 查询小程序礼物分成信息
 * extUuid
 */
export function getGiftShareConfigContent(extUuid) {
  return request({
    url: '/api/extApply/getGiftShareConfigContent',
    method: 'GET',
    params: {
      extUuid,
    },
  })
}
